import {
    AfterViewInit,
    Component, Inject,
    OnInit, ViewChild,
    ElementRef
} from '@angular/core';
import {
    FormGroup,
    FormBuilder,
    Validators
} from '@angular/forms';

import {
    Router
} from '@angular/router';

import {
    Observable
} from 'rxjs';

import {
    LoginModel,
    SecurityInfo
} from '../../../core/model/procedure.model';
import {
    LoginService
} from '../../../core/service/login.service';
import {
    SettingsService
} from '../../../core/settings/settings.service';

import {
    lowerCase
} from 'lodash';

function defaultEnterButton() {
    $('.password').on('keydown', function (e) {
        if (e.keyCode == 13) {
            $('.onLogin').click();
        }
    })
}

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss'],
    //encapsulation: ViewEncapsulation.None
})

export class LoginComponent implements OnInit, AfterViewInit {

    email: string = '';
    password: string = '';
    message: string = '';
    department: string = '';
    showSpinner: boolean = false;
    valForm: FormGroup;
    searchParam: LoginModel;

    //is
    isValid: boolean = false;
    isClient: boolean = true;
    isEmployee: boolean = false;
    //key
    keyLock: string = 'idLock';
    keyInput: string = 'idPassword';

    public idUser = 0;

    @ViewChild('loginGo') loginGo!: ElementRef<HTMLElement>;
    @ViewChild('loginUser') loginUser!: ElementRef<HTMLElement>;
    @ViewChild('loginPassword') loginPassword!: ElementRef<HTMLElement>;

    constructor(
        private fb: FormBuilder,
        private service: LoginService,
        public settings: SettingsService,
        private router: Router,
        @Inject('BASE_URL') private baseUrl: string) {
        this.valForm = fb.group({
            'email': [null, Validators.required],
            'password': [null, Validators.required]
        });
    }

    ngOnInit() {
        this.onInit();
    }
    ngAfterViewInit(): void {
        setTimeout(() => {
            this.loginUser.nativeElement.focus();
        }, 100);
        this.onInitUser();
    }
    //init
    onInit() {
        let e = '';

        this.email = e;
        this.password = e;
        this.message = e;
        this.isValid = false;
    }
    async onInitUser() {
        let s = this.service;
        let r = await s.userType();

        r.subscribe((data: string) => {
            let e = data != undefined;

            if (e) {
                let v = '' + data;

                e = v != undefined;
                if (e) {
                    e = lowerCase(v) == 'employee';
                }
            }
            this.isEmployee = e;
            s.isEmployee = e;
            e = !e;
            this.isClient = e;
            s.isClient = e;
        },
            err => {
                console.error(err);
            },
            () => {
                this.onByPass();
            });
    }
    //authenticate
    authenticate(item: LoginModel): Observable<SecurityInfo> {
        let result = this.service.authenticate(item);

        return result;
    }
    //login
    onLogin() {
        let ok = true;
        let em = this.email;
        let pw = this.password;
        let sp = new LoginModel();

        this.idUser = 0;
        this.showSpinner = ok;
        this.searchParam = sp;
        ok = em.length > 0 && pw.length > 0;
        if (ok) {
            sp.username = em;
            sp.password = pw;

            let result = this.authenticate(sp);

            result.subscribe((data: SecurityInfo) => {
                let id = 0;

                ok = data != null;
                if (ok) {
                    ok = data.valid;
                    if (ok) {
                        id = this.getUserId(data);
                    }
                }
                /*
                //by pass
                ok = true;
                */
                this.idUser = id;
                this.isValid = ok;
                if (ok) {
                    this.router
                        .navigate(['/home']);
                    this.service
                        .initialPermissions(data);
                }
                else {
                    this.onMessage('User not authorized for software');
                }
                this.isValid = ok;
                ok = false;
                this.showSpinner = ok;
            });
        }
        else {
            let m = 'Please enter ';

            if (this.isEmployee) {
                m += 'User Name';
            }
            else /*if (this.isClient)*/ {
                m += 'Email';
            }
            m += ' / Password';
            this.onMessage(m)
            this.isValid = ok;
            ok = false;
            this.showSpinner = ok;
        }
    }
    //message
    doMessage(style) {
        style.color = 'pink';
        var interval = window.setInterval(() => {
            style.color = 'red';
            window.clearInterval(interval);
            window.setTimeout(() => {
                this.doMessage(style);
            },
                1000);
        },
            1000);
    }
    onMessage(value: string) {
        this.message = value;
        /*
        if (value.length > 0) {
            let e;
    
            e = document.getElementById('idMessage');
            this.doMessage(e.style);
        }
        */
    }
    //lock
    onLock(lock: boolean) {
        let c;
        let e;
        let k = this.keyInput;
        let $e;
        let icon;
        let type;

        e = document.getElementById(k);
        $e = $('#' + k);
        if (lock) {
            c = 'black';
            icon = 'lock';
            type = 'password';
        }
        else {
            c = 'lightgray';
            icon = 'eye';
            type = 'text';
        }
        e.type = type;
        $e.css({
            'color': c
        });
        $e = $('#' + this.keyLock);
        $e.removeClass();
        $e.addClass('fa fa-' + icon);
    }
    onLockHover() {
        this.onLock(false);
    }
    onLockLeave() {
        this.onLock(true);
    }
    //user
    getUserId(item: object): number {
        let id = 0;
        let items = Object.keys(item);

        if (items != null) {
            let count = items.length;

            if (count > 0) {
                let key = (this.isEmployee ? 'contact' : 'externalContact') + 'Id';

                if (items.indexOf(key) > -1) {
                    id = item[key];
                }
            }
        }

        return id;
    }
    //by pass
    onByPass() {
        /*
        this.byPassOn();
       */
        this.byPassOff();
        this.onLogin();
    }
    byPassOn() {
        let e,
            p;

        if (this.isEmployee) {
            e = 'employee';
            p = 'agat';
        }
        else /*if (this.isClient)*/ {
            e = 'testuser@shell.com';
            //e = 'testuser@directenergy.com';
            p = 'sp33dbump';
        }
        this.email = e;
        this.password = p;
    }
    byPassOff() {
        let e = '';

        this.email = e;
        this.password = e;
    }
    onKey(event: KeyboardEvent) {
        let key = event.key.toLowerCase();
        let d = key === 'tab' || key == 'arrowdown';
        let u = key == 'arrowup';

        if (d ||
            u) {
            event.preventDefault();
            let e = <HTMLElement>event.currentTarget;
            let id = e.id;
            let eg = this.loginGo.nativeElement;
            let em = this.loginUser.nativeElement;
            let ep = this.loginPassword.nativeElement;

            switch (id) {
                case 'idEmail':
                    e = d ? ep : eg;
                    break;
                case 'idPassword':
                    e = d ? eg : em;
                    break;
                case 'idButtonLogin':
                case 'idUser':
                default:
                    e = d ? em : ep;
                    break;
            }
            e.focus();
        }
    }

}
